var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99896 8.07823V10.6266C3.99896 12.4879 3.99896 13.4185 4.24367 14.1717C4.73826 15.6939 5.93168 16.8873 7.45387 17.3819C8.20703 17.6266 9.13768 17.6266 10.999 17.6266C12.8602 17.6266 13.7909 17.6266 14.544 17.3819C16.0662 16.8873 17.2597 15.6939 17.7542 14.1717C17.999 13.4185 17.999 12.4879 17.999 10.6266V8.08152M17.999 8.08152C17.0417 8.46949 15.8591 8.89091 14.4518 9.39352L12.3444 10.1462C11.6785 10.384 11.3455 10.5029 10.9991 10.5029C10.6526 10.5029 10.3197 10.384 9.6537 10.1462L7.5463 9.39352C3.14564 7.82184 0.945312 7.03599 0.945312 5.62656C0.945312 4.21713 3.14564 3.43129 7.54631 1.8596L9.6537 1.10695C10.3197 0.869105 10.6526 0.750183 10.9991 0.750183C11.3455 0.750183 11.6785 0.869105 12.3444 1.10695L14.4518 1.8596C18.8525 3.43129 21.0528 4.21713 21.0528 5.62656C21.0528 6.58527 20.0351 7.25628 17.999 8.08152Z",
    stroke: "#77498F",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionIcon);
export default __webpack_public_path__ + "static/media/Session-Icon.5957b6d7213abbb17b9a4a2fb969fe3d.svg";
export { ForwardRef as ReactComponent };